import React from 'react'

const Pitches = () => {
    return (
        <div
            className="min-h-screen flex items-center justify-center bg-blue-900 text-3xl text-white"
        >
            <div>This is Pitches </div>
        </div>
    )
}

export default Pitches
